import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { Grid, Avatar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const SortableListRowIcon = ({ classes, children, transparent, ...props }) => (
  <Grid item className={classes.iconColumn} {...props}>
    {children && (
      <Avatar
        classes={{
          root: classes.avatarRoot,
          colorDefault: classNames({
            [classes.avatar]: !transparent,
            [classes.avatarTransparent]: transparent,
          }),
        }}
      >
        {children}
      </Avatar>
    )}
  </Grid>
);

const styles = theme => ({
  iconColumn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: theme.altus.largeRow.height,
    minWidth: theme.altus.largeRow.height,
    height: theme.altus.largeRow.height - 1,
  },
  iconColumnBackground: {
    background: theme.altus.background.header,
  },
  avatar: {
    background: theme.palette.primary.light,
  },
  avatarTransparent: {
    background: "transparent",
  },
  avatarRoot: {
    fontSize: theme.typography.body1.fontSize,
  },
});

SortableListRowIcon.defaultProps = {
  transparent: false,
};

export default compose(
  React.memo,
  withStyles(styles),
)(SortableListRowIcon);
